import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const EmptyInsightsText = styled.p`
  color: var(--text-soft);
  text-align: center;
  ${typographyV2.bodyXs};
  margin-top: 8px;
`;
